import React, { useEffect, useState } from 'react';
import { Form, Spin } from 'antd';
import { notification } from '@gamesb42/ui-kit';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { checkConfirmCode, setPasswordWithCode } from 'api/users';
import urls from 'constants/urls';
import { InvitePasswordForm, InvalidCodeScreen } from './components';
import Slider from '../LogIn/components/Slider';

import s from '../LogIn/styles.module.scss';

type InviteStatus = 'verifying' | 'verified' | 'expired' | 'no_code';

interface PasswordFormData {
  password: string;
  confirmPassword: string;
}

export default function InviteUser() {
  const [form] = Form.useForm();
  const [status, setStatus] = useState<InviteStatus>('verifying');
  const [passwordLoading, setPasswordLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const parsed = queryString.parse(location.search);
  const inviteCode = typeof parsed.code === 'string' ? parsed.code : '';

  useEffect(() => {
    if (!inviteCode) {
      setStatus('no_code');
      return;
    }

    let cancelled = false;

    const verify = async () => {
      try {
        await checkConfirmCode({ code: inviteCode });
        if (!cancelled) setStatus('verified');
      } catch {
        if (!cancelled) setStatus('expired');
      }
    };

    verify();

    return () => {
      cancelled = true;
    };
  }, [inviteCode]);

  const handleSetPassword = async (values: PasswordFormData) => {
    setPasswordLoading(true);
    try {
      await setPasswordWithCode({ code: inviteCode, password: values.password });

      notification.success({
        theme: 'dark',
        message: 'Password Set Successfully',
        description: 'Your password has been set. You can now sign in.',
        placement: 'bottomLeft',
      });

      history.push(urls.getAuth());
    } catch (error) {
      console.error('Set password error:', error);
      notification.error({
        theme: 'dark',
        message: 'Failed to Set Password',
        description: 'Something went wrong. Please try again.',
        placement: 'bottomLeft',
      });
    } finally {
      setPasswordLoading(false);
    }
  };

  const renderContent = () => {
    if (status === 'verifying') {
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}>
          <Spin size="large" />
        </div>
      );
    }

    if (status === 'verified') {
      return <InvitePasswordForm form={form} loading={passwordLoading} onFinish={handleSetPassword} />;
    }

    return <InvalidCodeScreen code={inviteCode} />;
  };

  return (
    <div className={s.root}>
      <div className={s.block} style={{ width: '50%', height: '100vh' }}>
        <Slider />
      </div>
      <div
        className={s.block}
        style={{ padding: '0 70px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div style={{ width: '452px' }}>{renderContent()}</div>
      </div>
    </div>
  );
}
